import styled from 'styled-components'
import { colors } from '../../branding'

export const StyledNavigation = styled.nav`
  background-color: white;
  width: 100vw;
  font-size: 18px;
  border-bottom: 2px solid ${colors.blueDark};
  max-height: 60px;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;

  .Navigation-box {
    width: var(--app-width);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 var(--content-padding-md);
  }
  
  .Navigation-logo {
    max-height: 50px;
  }

  .Navigation-menu,
  .Navigation-submenu {
    list-style: none;
    display: inline;
    padding: 0;
    color: ${colors.blueDark};
  }

  .Navigation-menu {
    li {
      display: inline;
      padding-right: 20px;
      position: relative;

      :last-child {
        padding-right: 0px;
      }
    }
  }
  

  .Navigation-submenu {
    display: block;
    position: absolute;
    top: 40px;
    left: -12px;
    background-color: ${colors.light};
    padding: 0 10px;
    height: 0;
    width: 196px;
    overflow: hidden;

    li {
      display: flex;
      align-items: center;
      width: 276px;
      max-width: 276px;
      height: 50px;
      overflow: hidden;
      padding: 0;
      
      span {
        font-size: 12px;
        display: block;
        color: ${colors.grey};
        font-weight: bold;
        padding-bottom: 5px;
        line-height: 10px;
      }

      :first-child {
        margin-top: 10px;
      }
      
      :last-child {
        border-bottom: none;
        margin-bottom: 10px;
      }
      
    }
    
    &.expanded {
      height: auto;
      border: 2px solid ${colors.blueDark};
      overflow-y: scroll;
    }
  }
  

  a,
  button {
    color: ${colors.blueDark};
    text-decoration: none;
    position: relative;
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    box-sizing: border-box;
  }
  
  .Navigation-menu {
    a,
    button {
      :before,
      :after {
        content: "";
        position: absolute;
        bottom: -5px;
        height: 2px;
        margin: 5px 0 0;
        transition: all 0.2s ease-in-out;
        background-color: ${colors.blueDark};
        left: 0;
      }


      :before {
        width: 100%;
        opacity: 1;
      }

      :not(.selected):before,
      :after {
        width: 0;
        opacity: 0;
      }


      :hover {
        :before,
        :after{
          width: 100%;
          opacity: 1;
        }
      }
    }
  }


  @media (max-width: 600px) {
    max-height: 100px;
    
    .Navigation-box {
      flex-direction: column;
    }
    
    .Navigation-menu {
      margin-top: 5px;
      
      li {
        position: unset;
      }
      
    }
    
    .Navigation-submenu {
      top: 98px;
      left: 10px;
      width: calc(100% - 45px);
      display: flex;
      flex-direction: column;
      align-items: center;
      
      li {
        justify-content: center;
        text-align: center;
      }
      
    }
  }

  @media (max-width: 420px) {
    font-size: 12px;

    .Navigation-menu {
      li {
        padding-right: 5px;
        button {
          svg {
            position: relative;
            top: 2px;
          }
        }
      }
    }

    .Navigation-submenu {
      top: 86px;
      
      li {
        height: 40px;
        
        span {
          font-size: 10px;
        }
      }
    }
  }
`
